import { t } from '@/infra/i18n';

interface Props {
  onReload: () => void;
}

export function ErrorFallback({ onReload }: Props) {
  return (
    <div
      role="alertdialog"
      aria-labelledby="err-title"
      aria-describedby="err-body"
      style={overlay}
    >
      <div style={card}>
        <h1 id="err-title" style={title}>
          {t('error.generic.title')}
        </h1>
        <p id="err-body" style={body}>
          {t('error.generic.body')}
        </p>
        <button data-testid="error-fallback-reload-button" onClick={onReload} style={button}>
          {t('error.generic.button')}
        </button>
      </div>
    </div>
  );
}

const overlay: React.CSSProperties = {
  position: 'fixed',
  inset: 0,
  background: 'rgba(10, 10, 10, 0.95)',
  display: 'grid',
  placeItems: 'center',
  zIndex: 9999,
  padding: 16,
};

const card: React.CSSProperties = {
  background: '#1a1a2e',
  border: '1px solid #3a3a4e',
  borderRadius: 12,
  padding: 24,
  maxWidth: 420,
  width: '100%',
  textAlign: 'center',
  color: '#f0f0f0',
};

const title: React.CSSProperties = {
  margin: '0 0 12px 0',
  fontSize: '1.2rem',
  color: '#ffd6b3',
};

const body: React.CSSProperties = {
  margin: '0 0 20px 0',
  fontSize: '0.95rem',
  color: '#cccccc',
  lineHeight: 1.5,
};

const button: React.CSSProperties = {
  background: '#3a6a3a',
  border: '1px solid #5a8a5a',
  color: '#f0f0f0',
  borderRadius: 8,
  padding: '10px 20px',
  fontSize: '0.95rem',
  cursor: 'pointer',
  minHeight: 44,
};
